// extracted by mini-css-extract-plugin
export default {"icon":"Icon-module__icon__67Kqb","assetIcon":"Icon-module__assetIcon__MX4nP"};